//#region IMPORT
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
/** Components Import */
import {
  Stack,
  Typography,
  TextField,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import { Dialog, Button } from '../../../../Components/MUIs';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';

/** Icons Import */

import {
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Close as CloseIcon,
  Add as AddIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from '@mui/material';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './POL_BASIC_02_ColumnDefs';
import FileUploadDialog from '../../../../Components/FileUploadDialog/FileUploadDialog';

//#endregion
function POL_BASIC_02(props) {
  //#region 변수
  const searchInfo = useSelector((state) => state.SearchInfo);
  const [expandedCategoryId, setExpandedCategoryId] = useState(null);
  //#endregion

  //#region 웹
  // dtl 컬럼: 공통 컬럼정의 파일만 사용
  const columnDefs = useMemo(
    () => getColumnDefs1(props),
    [props.rowData1, props.gubunList, props.gubun2Map]
  );

  //#endregion
  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick2) {
      if (!props.validateSelection()) {
        props.setFilterClick2(false);
        return;
      }

      props.gridRef1.current.api &&
        props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick2(false);
    }
    if (props.searchClick2) {
      if (!props.validateSelection()) {
        props.setSearchClick2(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick2(false);
    }
    if (props.addClick2) {
      if (!props.validateSelection()) {
        props.setAddClick2(false);
        return;
      }

      const loadDataBeforeAdd = async () => {
        try {
          // [보류] 구분/세부목표를 텍스트 직접입력으로 전환하면서
          // 카테고리 사전로딩(loadCategoryItems)은 잠시 비활성화.
          // if (!props.gubunList || props.gubunList.length === 0) {
          //   await props.loadCategoryItems?.(false);
          // }
        } catch (e) {
          // 로드 실패해도 추가는 진행
          console.log(e);
        }
      };

      loadDataBeforeAdd()
        .then(() => {
          GridFunctions.addClick(props.gridRef1, props.setChangedRowData1);
          props.setAddClick2(false);
        })
        .catch(() => {
          GridFunctions.addClick(props.gridRef1, props.setChangedRowData1);
          props.setAddClick2(false);
        });
    }
    if (props.saveClick2) {
      if (!props.validateSelection()) {
        props.setSaveClick2(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick2(false);
    }
    if (props.deleteClick2) {
      if (!props.validateSelection()) {
        props.setDeleteClick2(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick2(false);
    }
    if (props.printClick2) {
      if (!props.validateSelection()) {
        props.setPrintClick2(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick2(false);
    }
    if (props.listClick2) {
      if (!props.validateSelection()) {
        props.setListClick2(false);
        return;
      }

      props.setModalToggle3(true);
      props.SearchLogic4();
      props.setListClick2(false);
    }
  }, [
    props.filterClick2,
    props.searchClick2,
    props.addClick2,
    props.saveClick2,
    props.deleteClick2,
    props.printClick2,
    props.listClick2,
  ]);
  //#endregion

  // 코드관리(아코디언) expanded 상태를 controlled로 관리 (MUI warning 방지)
  useEffect(() => {
    const visibleCategories = (props.categoryList || []).filter(
      (c) => c.deleteYn !== 'Y'
    );
    if (visibleCategories.length === 0) {
      setExpandedCategoryId(null);
      return;
    }

    const getKey = (c) => c._tempId || c.categoryId;

    const exists = visibleCategories.some(
      (c) => getKey(c) === expandedCategoryId
    );

    if (!expandedCategoryId || !exists) {
      setExpandedCategoryId(getKey(visibleCategories[0]));
    }
  }, [props.categoryList, expandedCategoryId]);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ py: 2, backgroundColor: '#FFF', borderRadius: '10px' }}>
        <TableContainer component={Paper} sx={{ px: 2 }}>
          <Table sx={{ width: '100%' }}>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '80%' }} />
            </colgroup>
            <TableBody>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    borderRight: 1,
                    borderBottom: 'none',
                    borderColor: 'divider',
                    fontSize: '16px',
                    backgroundColor: 'rgb(250, 250, 250)',
                  }}
                >
                  {'전사 목표'}
                </TableCell>
                <TableCell
                  align="center"
                  colSpan={5}
                  sx={{
                    borderColor: 'divider',
                    p: '8px',
                    borderBottom: 'none',
                  }}
                >
                  <TextField
                    fullWidth
                    value={props.inputs?.goal ? props.inputs?.goal : ''}
                    onChange={(e) => {
                      props.setinputs((prevState) => ({
                        ...prevState,
                        goal: e.target.value,
                      }));
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '16px',
                      },
                    }}
                    size="small"
                    multiline={true}
                    rows={3}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box sx={{ flex: 1 }}>
        <BusinessGridCommon
          getRowId={(params) => {
            return params.data.no;
          }}
          gridRef={props.gridRef1}
          editable={true}
          columnDefs={columnDefs}
          rowData={props.rowData1}
          setSelectedRowData={props.setSelectedRowData1}
          setChangedRowData={props.setChangedRowData1}
          title1={'안전보건목표 및 추진계획 기본정보'}
          rowSelection={'multiple'}
          fileUploadYn1="Y"
          fileUploadClick1={() => {
            if (!props.validateSelection()) return;
            props.fileInputRef?.current?.click();
          }}
          fileDownloadYn1="Y"
          fileDownloadClick1={() => {
            if (!props.validateSelection()) return;

            props.ExcelDownload1(props.inputs, props.rowData1);
          }}
          addClick1={async () => {
            if (!props.validateSelection()) return;

            try {
              // [보류] 구분/세부목표를 텍스트 직접입력으로 전환하면서
              // 카테고리 사전로딩(loadCategoryItems)은 잠시 비활성화.
              // if (!props.gubunList || props.gubunList.length === 0) {
              //   await props.loadCategoryItems?.(false);
              // }
            } catch (e) {
              console.log(e);
            }

            GridFunctions.addClick(props.gridRef1, props.setChangedRowData1);
          }}
          deleteClick1={(e) => {
            if (!props.validateSelection()) return;

            const newRowExists = props.selectedRowData1.some(
              (row) => row.newYn === 'Y'
            );

            if (!newRowExists) {
              props.MarkedForDeletion1(props.selectedRowData1);
            } else {
              props.NewYnErrorMsg();
            }
          }}
          refreshClick1={() => {
            if (!props.validateSelection()) return;

            props.SearchLogic1();
          }}
          onCellClicked={(e) => {
            const gridApi = props.gridRef1.current.api;
            const clickedRowIndex = e.rowIndex;

            const isCheckboxClick = e.event?.target?.type === 'checkbox';

            if (!isCheckboxClick) {
              gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
              // gridApi.setFocusedCell(clickedRowIndex, 'coNm'); // 해당 셀로 포커스 이동

              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);
            }
          }}
          onSelectionChanged={() => {
            const gridApi = props.gridRef1?.current?.api;
            const selectedNodes = gridApi.getSelectedNodes();
            const selectedData = selectedNodes.map((n) => n.data);
            props.selectedRowNosRef1.current = new Set(
              selectedData.map((r) => r.no)
            );
            props.setSelectedRowData1(selectedData);
          }}
          onCellValueChanged={(e) => {
            // 변경 데이터 처리
            const key = e.data.no;
            const updatedRow = { ...e.data, editYn: 'Y' };

            props.setChangedRowData1?.((prev = []) => {
              const filtered = prev.filter((row) => row.no !== key);
              return [...filtered, updatedRow];
            });
          }}
          // [보류] 구분/세부목표를 텍스트 직접입력으로 전환하면서
          // 코드관리(항목관리) 버튼은 잠시 비활성화.
          // other1={
          //   <Button
          //     name="항목관리"
          //     onClick={() => {
          //       if (props.handleCodeManagementClick) {
          //         props.handleCodeManagementClick();
          //       }
          //     }}
          //   />
          // }
        />
      </Box>
      {props.fileModalToggle && (
        <FileUploadDialog
          open={props.fileModalToggle}
          onClose={() => props.setFileModalToggle(false)}
          gridRef={props.gridRef1}
          selectedRowData={props.selectedRowData1}
          setSelectedRowData={props.setSelectedRowData1}
          setChangedRowData={props.setChangedRowData1}
          fileNameField="fileName"
          filePathField="filePath"
          SaveLogicPreview={props.SaveLogicPreview}
          DownloadLogic={props.DownloadLogic1}
          title="파일 업로드"
          filePreviewHeight="600px"
        />
      )}

      {/* 코드관리 팝업 */}
      {props.modalToggle1.codeManagement && (
        <Dialog
          open={props.modalToggle1.codeManagement}
          onClose={() =>
            props.setModalToggle1((prev) => ({
              ...prev,
              codeManagement: false,
            }))
          }
          maxWidth="md"
          fullWidth
          title={null}
          titleSx={{
            display: 'none',
            padding: 0,
            margin: 0,
            borderBottom: 'none',
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            p: 0,
            overflow: 'hidden',
            maxHeight: '90vh',
          }}
          PaperProps={{
            sx: {
              borderRadius: 0,
              overflow: 'hidden',
              maxHeight: '90vh',
              height: 'auto',
            },
          }}
          saveButtonName={null}
          closeButtonName={null}
          useSaveButton={false}
          useCloseButton={false}
          useSaveAfterClose={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  whiteSpace: 'nowrap',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                  zIndex: 20,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '20px',
                      }}
                    >
                      ⚙️
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#111418',
                        fontSize: 22,
                        fontWeight: 'bold',
                        letterSpacing: -0.15,
                        mb: 0.5,
                      }}
                    >
                      항목관리
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#617589',
                        fontSize: 14,
                        lineHeight: 1.5,
                      }}
                    >
                      구분 및 세부목표를 관리합니다
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      props.setModalToggle1((prev) => ({
                        ...prev,
                        categoryDetail: true,
                        mode: 'ADD',
                        categoryTarget: { categoryId: 0, categoryName: '' },
                      }));
                    }}
                    sx={{
                      color: '#ffffff',
                      fontSize: 14,
                      fontWeight: 600,
                      px: 2.5,
                      py: 1,
                      backgroundColor: '#1976d2',
                      boxShadow: '0 2px 4px rgba(25, 118, 210, 0.3)',
                      '&:hover': {
                        backgroundColor: '#1565c0',
                        boxShadow: '0 4px 8px rgba(25, 118, 210, 0.4)',
                      },
                    }}
                  >
                    항목추가
                  </Button>
                  <IconButton
                    onClick={() =>
                      props.setModalToggle1((prev) => ({
                        ...prev,
                        codeManagement: false,
                      }))
                    }
                    size="small"
                    sx={{
                      color: '#617589',
                      '&:hover': {
                        color: '#111418',
                        bgcolor: 'transparent',
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Paper>

              {/* 컨텐츠 영역 */}
              <Box
                sx={{
                  flex: 1,
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                  maxHeight: 'calc(90vh - 180px)',
                  p: 2,
                }}
              >
                {/* 아코디언 리스트 */}
                <Box
                  sx={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    minHeight: 0,
                    '&::-webkit-scrollbar': {
                      width: '8px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(0, 0, 0, 0.2)',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1',
                    },
                  }}
                >
                  {props.categoryList.length === 0 ? (
                    <Box
                      sx={{
                        textAlign: 'center',
                        py: 6,
                        color: '#617589',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: '0.875rem',
                        }}
                      >
                        구분을 추가해주세요.
                      </Typography>
                    </Box>
                  ) : (
                    (props.categoryList || [])
                      .filter((c) => c.deleteYn !== 'Y')
                      .map((category, index) => {
                        const accKey = category._tempId || category.categoryId;
                        return (
                          <Accordion
                            key={accKey}
                            expanded={expandedCategoryId === accKey}
                            onChange={(_e, isExpanded) => {
                              setExpandedCategoryId(isExpanded ? accKey : null);
                            }}
                            sx={{
                              mb: 3,
                              borderRadius: 1,
                              border: '1px solid #dbe0e6',
                              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                              backgroundColor: 'white',
                              '&:before': {
                                display: 'none',
                              },
                              '&.Mui-expanded': {
                                margin: '0 0 24px 0',
                                backgroundColor: 'white',
                                border: '1px solid #dbe0e6',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
                              },
                            }}
                          >
                            <AccordionSummary
                              expandIcon={
                                <ExpandMoreIcon
                                  sx={{
                                    color: '#617589',
                                    fontSize: '24px',
                                  }}
                                />
                              }
                              aria-controls={`panel-${accKey}-content`}
                              id={`panel-${accKey}-header`}
                              sx={{
                                bgcolor: 'white',
                                borderRadius: '4px 4px 0 0',
                                minHeight: 56,
                                px: 2.5,
                                borderBottom: '1px solid #e5e7eb',
                                '&.Mui-expanded': {
                                  minHeight: 56,
                                  borderBottom: '2px solid #dbe0e6',
                                },
                                '&:hover': {
                                  bgcolor: '#f9fafb',
                                },
                                '& .MuiAccordionSummary-content': {
                                  margin: '12px 0',
                                  alignItems: 'center',
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  pr: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      borderRadius: '6px',
                                      backgroundColor:
                                        'rgba(19, 127, 236, 0.1)',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontWeight: 600,
                                      fontSize: '0.75rem',
                                      color: 'primary.main',
                                    }}
                                  >
                                    {index + 1}
                                  </Box>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      color: '#111418',
                                      fontWeight: 600,
                                      fontSize: '0.9375rem',
                                    }}
                                  >
                                    {category.categoryName}
                                  </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      props.setModalToggle1((prev) => ({
                                        ...prev,
                                        categoryDetail: true,
                                        mode: 'EDIT',
                                        categoryTarget: { ...category },
                                      }));
                                    }}
                                    sx={{
                                      color: '#617589',
                                      '&:hover': {
                                        backgroundColor: '#f3f4f6',
                                        color: '#111418',
                                      },
                                    }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      props.setCategoryList((prev = []) => {
                                        // 신규(아직 서버에 없는) 카테고리는 그냥 제거
                                        const isNewCategory =
                                          category.newYn === 'Y' ||
                                          category.categoryId === 0 ||
                                          String(
                                            category.categoryId || ''
                                          ).startsWith('new_');

                                        if (isNewCategory) {
                                          return prev.filter(
                                            (c) =>
                                              c.categoryId !==
                                              category.categoryId
                                          );
                                        }

                                        // 기존 카테고리는 deleteYn으로 "삭제 표시"
                                        return prev.map((c) =>
                                          c.categoryId === category.categoryId
                                            ? { ...c, deleteYn: 'Y' }
                                            : c
                                        );
                                      });
                                    }}
                                    sx={{
                                      color: '#617589',
                                      '&:hover': {
                                        backgroundColor: '#f3f4f6',
                                        color: '#111418',
                                      },
                                    }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              </Box>
                            </AccordionSummary>
                            <AccordionDetails
                              sx={{
                                px: 2.5,
                                py: 3,
                                backgroundColor: '#f9fafb',
                              }}
                            >
                              <Stack spacing={3}>
                                {/* 구분상세 입력 영역 */}
                                <Paper
                                  elevation={0}
                                  sx={{
                                    backgroundColor: 'white',
                                    borderRadius: 1,
                                    padding: 2.5,
                                    border: '1px solid #e5e7eb',
                                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 2,
                                      pb: 1.5,
                                      borderBottom: '2px solid #f0f2f4',
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        fontWeight: 600,
                                        color: '#111418',
                                        fontSize: '0.875rem',
                                      }}
                                    >
                                      세부목표
                                    </Typography>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        const updatedList =
                                          props.categoryList.map((c) =>
                                            c.categoryId === category.categoryId
                                              ? {
                                                  ...c,
                                                  items: [
                                                    ...(c.items || []),
                                                    {
                                                      itemId: 0,
                                                      itemName: '',
                                                      sortOrder:
                                                        (c.items?.length || 0) +
                                                        1,
                                                      deleteYn: 'N',
                                                      newYn: 'Y',
                                                    },
                                                  ],
                                                }
                                              : c
                                          );
                                        props.setCategoryList(updatedList);
                                      }}
                                      sx={{
                                        color: '#617589',
                                        '&:hover': {
                                          backgroundColor: '#f3f4f6',
                                          color: '#111418',
                                        },
                                      }}
                                    >
                                      <AddIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                  <Stack spacing={1.5}>
                                    {(category.items || []).map(
                                      (item, itemIndex) => {
                                        if (item?.deleteYn === 'Y') return null;

                                        const itemDetail =
                                          category.itemDetails &&
                                          category.itemDetails[itemIndex];
                                        const uniqueKey =
                                          itemDetail && itemDetail.itemId
                                            ? `${category.itemId}_item_${itemDetail.itemId}`
                                            : `${category.itemId}_item_${itemIndex}`;

                                        return (
                                          <Box
                                            key={uniqueKey}
                                            sx={{
                                              display: 'flex',
                                              gap: 1.5,
                                              alignItems: 'flex-start',
                                              backgroundColor: '#ffffff',
                                              borderRadius: 1,
                                              padding: 1.5,
                                              border: '1px solid #f0f2f4',
                                              '&:hover': {
                                                borderColor: '#dbe0e6',
                                              },
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                minWidth: 24,
                                                height: 24,
                                                borderRadius: '4px',
                                                bgcolor:
                                                  'rgba(19, 127, 236, 0.1)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'primary.main',
                                                fontWeight: 600,
                                                fontSize: '0.75rem',
                                                mt: 0.5,
                                              }}
                                            >
                                              {itemIndex + 1}
                                            </Box>
                                            <TextField
                                              fullWidth
                                              value={item.itemName}
                                              onChange={(e) => {
                                                const updatedList =
                                                  props.categoryList.map(
                                                    (c) => {
                                                      if (
                                                        c.categoryId ===
                                                        category.categoryId
                                                      ) {
                                                        const newItems = [
                                                          ...(c.items || []),
                                                        ];
                                                        const prevItem =
                                                          newItems[itemIndex] ||
                                                          {};

                                                        newItems[itemIndex] = {
                                                          ...prevItem,
                                                          itemName:
                                                            e.target.value,
                                                          ...(prevItem.newYn ===
                                                          'Y'
                                                            ? {}
                                                            : { editYn: 'Y' }),
                                                        };

                                                        return {
                                                          ...c,
                                                          items: newItems,
                                                        };
                                                      }
                                                      return c;
                                                    }
                                                  );
                                                props.setCategoryList(
                                                  updatedList
                                                );
                                              }}
                                              placeholder="세부목표를 입력하세요"
                                              size="small"
                                              autoFocus={
                                                itemIndex ===
                                                  category.items.length - 1 &&
                                                item === ''
                                              }
                                              sx={{
                                                '& .MuiOutlinedInput-root': {
                                                  backgroundColor: '#ffffff',
                                                  '& fieldset': {
                                                    borderColor: '#e5e7eb',
                                                  },
                                                  '&:hover fieldset': {
                                                    borderColor: '#d1d5db',
                                                  },
                                                  '&.Mui-focused fieldset': {
                                                    borderColor: 'primary.main',
                                                  },
                                                },
                                              }}
                                            />
                                            {category.items.length > 0 && (
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  const updatedList =
                                                    props.categoryList.map(
                                                      (c) => {
                                                        if (
                                                          c.categoryId !==
                                                          category.categoryId
                                                        ) {
                                                          return c;
                                                        }

                                                        const nextItems = [
                                                          ...(c.items || []),
                                                        ];
                                                        const target =
                                                          nextItems[
                                                            itemIndex
                                                          ] || {};

                                                        // 신규(아직 서버에 없는) 아이템은 그냥 제거
                                                        const isNewItem =
                                                          target.newYn ===
                                                            'Y' ||
                                                          !target.itemId ||
                                                          target.itemId === 0;

                                                        if (isNewItem) {
                                                          return {
                                                            ...c,
                                                            items:
                                                              nextItems.filter(
                                                                (_, idx) =>
                                                                  idx !==
                                                                  itemIndex
                                                              ),
                                                          };
                                                        }

                                                        // 기존 아이템은 deleteYn으로 "삭제 표시"
                                                        nextItems[itemIndex] = {
                                                          ...target,
                                                          deleteYn: 'Y',
                                                        };

                                                        return {
                                                          ...c,
                                                          items: nextItems,
                                                        };
                                                      }
                                                    );

                                                  props.setCategoryList(
                                                    updatedList
                                                  );
                                                }}
                                                sx={{
                                                  mt: 0.5,
                                                  color: '#617589',
                                                  '&:hover': {
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#111418',
                                                  },
                                                }}
                                              >
                                                <DeleteIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          </Box>
                                        );
                                      }
                                    )}
                                  </Stack>
                                </Paper>
                              </Stack>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })
                  )}
                </Box>

                {/* 하단 버튼 */}
                <Paper
                  elevation={0}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1.5,
                    px: 3,
                    py: 2,
                    borderTop: '1px solid #f0f2f4',
                    bgcolor: 'white',
                    flexShrink: 0,
                  }}
                >
                  <Button
                    onClick={() =>
                      props.setModalToggle1((prev) => ({
                        ...prev,
                        codeManagement: false,
                      }))
                    }
                    variant="outlined"
                    sx={{
                      minWidth: '100px',
                      color: '#617589',
                      borderColor: '#e5e7eb',
                      fontWeight: 500,
                      '&:hover': {
                        borderColor: '#d1d5db',
                        bgcolor: 'transparent',
                      },
                    }}
                  >
                    취소
                  </Button>
                  <Button
                    onClick={props.SaveLogic5}
                    variant="contained"
                    sx={{
                      minWidth: '100px',
                      fontWeight: 500,
                    }}
                  >
                    저장
                  </Button>
                </Paper>
              </Box>
            </Box>
          }
        />
      )}

      {/* 구분 추가 및 수정 통합 팝업 */}
      {props.modalToggle1.categoryDetail && (
        <Dialog
          open={props.modalToggle1.categoryDetail}
          onClose={() =>
            props.setModalToggle1((prev) => ({
              ...prev,
              categoryDetail: false,
              categoryTarget: null,
            }))
          }
          title={null}
          titleSx={{
            display: 'none',
            padding: 0,
            margin: 0,
            borderBottom: 'none',
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            p: 0,
            overflow: 'hidden',
          }}
          PaperProps={{
            sx: {
              borderRadius: 0,
              overflow: 'hidden',
            },
          }}
          fullWidth
          maxWidth="sm"
          saveButtonName={null}
          closeButtonName={null}
          useSaveButton={false}
          useCloseButton={false}
          useSaveAfterClose={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
              }}
            >
              {/* 헤더 */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  whiteSpace: 'nowrap',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <AddIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    {props.modalToggle1.mode === 'EDIT'
                      ? '구분 수정'
                      : '구분 추가'}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() =>
                    props.setModalToggle1((prev) => ({
                      ...prev,
                      categoryDetail: false,
                      categoryTarget: null,
                    }))
                  }
                  size="small"
                  sx={{
                    color: '#617589',
                    '&:hover': {
                      color: '#111418',
                      bgcolor: 'transparent',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* 컨텐츠 */}
              <Box sx={{ p: 3 }}>
                <Stack spacing={2.5}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#f0f7ff',
                      borderRadius: 1,
                      padding: 2,
                      border: '1px solid #e0ecf9',
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#1976d2',
                        fontWeight: 600,
                        mb: 0.5,
                        fontSize: '0.8125rem',
                      }}
                    >
                      {props.modalToggle1.mode === 'EDIT'
                        ? '구분 수정 안내'
                        : '구분 추가 안내'}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#617589',
                        lineHeight: 1.6,
                        fontSize: '0.8125rem',
                      }}
                    >
                      {props.modalToggle1.mode === 'EDIT'
                        ? '기존 구분명을 수정할 수 있습니다.'
                        : '구분은 안전보건목표 및 추진계획을 분류하기 위한 대분류입니다. 추가 후 세부목표를 작성할 수 있습니다.'}
                    </Typography>
                  </Paper>
                  <TextField
                    label="구분명"
                    variant="outlined"
                    fullWidth
                    value={
                      props.modalToggle1.categoryTarget?.categoryName || ''
                    }
                    onChange={(e) => {
                      props.setModalToggle1((prev) => ({
                        ...prev,
                        categoryTarget: {
                          ...prev.categoryTarget,
                          categoryName: e.target.value,
                        },
                      }));
                    }}
                    placeholder="예: 안전보건목표, 추진계획 등"
                    required
                    helperText="안전보건목표 및 추진계획을 분류하는 대분류명을 입력하세요"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: '#ffffff',
                        '& fieldset': {
                          borderColor: '#e5e7eb',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d1d5db',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'primary.main',
                        },
                      },
                    }}
                  />
                </Stack>
              </Box>

              {/* 하단 버튼 */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 1.5,
                  px: 3,
                  py: 2,
                  borderTop: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  flexShrink: 0,
                }}
              >
                <Button
                  onClick={() =>
                    props.setModalToggle1((prev) => ({
                      ...prev,
                      categoryDetail: false,
                      categoryTarget: null,
                    }))
                  }
                  variant="outlined"
                  sx={{
                    minWidth: '80px',
                    color: '#617589',
                    borderColor: '#e5e7eb',
                    fontWeight: 500,
                    '&:hover': {
                      borderColor: '#d1d5db',
                      bgcolor: 'transparent',
                    },
                  }}
                >
                  닫기
                </Button>
                <Button
                  onClick={() =>
                    props.handleCategorySave(
                      props.modalToggle1.categoryTarget?.categoryName
                    )
                  }
                  variant="contained"
                  sx={{
                    minWidth: '80px',
                    fontWeight: 500,
                  }}
                >
                  {props.modalToggle1.mode === 'EDIT' ? '저장' : '등록'}
                </Button>
              </Paper>
            </Box>
          }
        />
      )}
      {/* 엑셀 업로드용 숨김 파일 input */}
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx,.xls"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.ExcelUpload1(file);
            // 같은 파일을 다시 선택할 수 있도록 초기화
            e.target.value = '';
          }
        }}
      />
    </Box>
  );
}

export default POL_BASIC_02;
